import { render } from "./LogoutButton.vue?vue&type=template&id=3a3e158a&scoped=true"
import script from "./LogoutButton.vue?vue&type=script&lang=js"
export * from "./LogoutButton.vue?vue&type=script&lang=js"

import "./LogoutButton.vue?vue&type=style&index=0&id=3a3e158a&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-3a3e158a"

export default script